import {Component, Input} from "@angular/core";
import { SuggestedWordService } from "../../services/suggested-word.service";
import {ContentSearchParamsFactoryService} from "../../services/factories/content-search-params-factory.service";
import {WindowRefService} from "../../../shared/services/window-ref.service";

@Component({
    selector: "pcg-ng-suggested-word",
    template: require('./suggested-word.component.html')
})
export class SuggestedWordComponent {
    @Input()
    public suggestedWord: string;

    public constructor(
        private suggestedWordService: SuggestedWordService,
        private contentSearchParamsFactoryService: ContentSearchParamsFactoryService,
        private windowRefService: WindowRefService
    ) {
    }

    public handleSuggestedWorClick(): boolean {
        this.suggestedWordService.searchBySuggestedWord(this.suggestedWord);

        return false;
    }

    public generateUrl(): string {
        const queryString = WindowRefService.getQueryString();
        const searchParams = this.contentSearchParamsFactoryService.createParamsByQueryString(queryString);
        searchParams.searchText = this.suggestedWord;
        const serializedParams = this.contentSearchParamsFactoryService.serialiseToQueryString(searchParams);

        const location = this.windowRefService.nativeWindow.location;

        const url = `${location.protocol}//${location.host}${location.pathname}?${serializedParams}`;
        return url;
    }
}
